export const PROJECT_FILE_EXTENSIONS = {
    styleExtensions: ['css'],
    scriptExtensions: ['js']
};
